<template>
  <u-animate-container id="index_product">
    <div v-show="show" class="video-list">
      <div
        class="video-list-item"
        :class="[activeIndex === index ? 'active' : '']"
        v-for="(item, index) in product"
        :key="index"
        @click="handleClick(item.demoVideo, index)"
      >
        {{ item.name }}
      </div>
      <div class="video-list-item">
        <router-link to="/product/0">{{ $t("index.product") }}</router-link>
      </div>
    </div>
    <video v-show="show" autoplay ref="myVideo" loop width="100%" height="100%">
      <source :src="activeUrl" type="video/mp4" style="width: 100%;" />
    </video>
    <template v-if="!show">
      <img
        src="@/assets/images/icon_prev.png"
        class="prev web"
        @click="prevProduct"
      />
      <img
        src="@/assets/images/icon_next.png"
        class="next web"
        @click="nextProduct"
      />
      <div class="container">
        <div class="list web" :style="distance">
          <u-animate
            class="item"
            v-for="(item, index) in product"
            :key="item.pcId + item.englishName"
            name="fadeInDown"
            delay="0s"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
          >
            <template @click="handleToggle(item, index)">
              <div class="nav">
                <div class="nav_item"></div>
                <div class="nav_item"></div>
                <div class="nav_item"></div>
              </div>
              <img
                :src="item.image"
                class="item_product_img"
                :alt="item.keyword"
                @click="handleToggle(item, index)"
              />
              <p class="item_product_title">
                {{ item.name }}
              </p>
              <p class="item_product_desc">
                {{ item.englishName }}
              </p>
              <div class="item_product_cate">
                <a href="#">cate1</a>
                <a href="#">cate1</a>
                <a href="#">cate1</a>
              </div>
              <div
                class="btn_more"
                @click="goDetail(item.pcId)"
                @touchstart.stop.prevent="goDetail(item.pcId)"
                :id="item.pcid"
              >
                <img src="@/assets/images/btn_index_product_more.png" />
              </div>
            </template>
          </u-animate>
        </div>
        <div class="list mobile" :style="distance">
          <transition
            mode="out-in"
            enter-active-class="animated fadeIn"
            v-for="(item, index) in product"
            :key="item.productId + item.desc"
          >
            <div class="item">
              <div class="nav">
                <div class="nav_item"></div>
                <div class="nav_item"></div>
                <div class="nav_item"></div>
              </div>
              <img
                :src="item.image"
                class="item_product_img"
                @click="handleToggle(item, index)"
              />
              <p class="item_product_title">
                {{ item.name }}
              </p>
              <p class="item_product_desc">
                {{ item.englishName }}
              </p>
              <div class="item_product_cate">
                <a href="#">cate1</a>
                <a href="#">cate1</a>
                <a href="#">cate1</a>
              </div>
              <div class="btn_more" @click="goProduct(item.pcId)">
                <img src="@/assets/images/btn_index_product_more.png" />
              </div>
            </div>
          </transition>
        </div>
      </div>
      <u-animate
        class="btn_know_more"
        name="zoomIn"
        delay="1.2s"
        duration="1s"
        :iteration="1"
        :offset="0"
        animateClass="animated"
        :begin="false"
      >
        <router-link to="/product/0">{{ $t("index.product") }}</router-link>
      </u-animate>
    </template>
  </u-animate-container>
</template>

<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
const productbg = require("@/assets/images/bg_index_knowmore.jpg");
export default {
  components: {
    UAnimateContainer,
    UAnimate
  },
  data() {
    return {
      index: 0,
      distance: {
        transform: ""
      },
      LENGTH: 5,
      bg: {
        background: "url(" + productbg + ") no-repeat center center",
        "background-size": "cover"
      },
      activeUrl: "",
      activeIndex: 0,
      show: false
    };
  },
  watch: {
    index(newval, oldval) {
      this.index = newval;
    }
  },
  created() {
    // console.log('产品数据', this.product)
  },
  props: {
    locale: {
      type: String,
      default: "cn"
    },
    product: {
      type: Array,
      default: function() {
        return {};
      }
    }
  },

  methods: {
    handleToggle(item, index) {
      this.activeUrl = item.demoVideo;
      this.show = true;
      this.handleClick(item.demoVideo, index);
    },
    handleClick(url, index) {
      const videoElement = this.$refs.myVideo;
      this.activeIndex = index;
      videoElement.pause();
      // 假设这里有两个视频源 video1Src 和 video2Src
      videoElement.src = url;
      videoElement.load();
      videoElement.play();
      this.$forceUpdate();
    },
    goProduct(e) {
      this.$router.push({
        name: "Product",
        params: {
          id: e
        }
      });
    },
    prevProduct() {
      if (this.index >= 0) {
        return false;
      } else {
        this.index += 1;
      }
      this.$set(
        this.distance,
        "transform",
        "translateX(" + this.index * 295 + "px)"
      );
      console.log(this.index);
    },
    nextProduct() {
      if (this.LENGTH - Math.abs(this.index) <= 3) {
        return false;
      } else {
        this.index -= 1;
      }
      this.$set(
        this.distance,
        "transform",
        "translateX(" + this.index * 295 + "px)"
      );
      console.log(this.index);
    },
    goDetail(e) {
      console.log("detailid", e);
      var _id = e;
      this.$router.push({
        name: "Product",
        params: {
          id: _id
        }
      });
    }
  },
  mounted() {
    this.$set(this.distance, "transform", "translateX(0px)");

    this.handleClick(this.product[0].demoVideo, 0);
    // this.distance.transform = 'tranlateX(-200px)'
  }
};
</script>

<style scoped lang="scss">
.video-list {
  position: absolute;
  left: 0.5rem;
  top: 1rem;
  z-index: 2;
  color: white;
  background: rgba(143, 130, 130, 0.2);
  padding: 0.3rem;
  &-item {
    font-size: 0.4rem;
    margin-bottom: 0.2rem;
    margin-left: 0.2rem;
    cursor: pointer;
    &:hover,
    &.active {
      color: #fb8001;
    }
    > a {
      color: white;
      cursor: pointer;
      text-decoration: none;
      &:hover,
      &.active {
        color: #fb8001;
      }
    }
  }
}
#index_product {
  width: 100%;
  height: auto;
  overflow: hidden;
  box-sizing: border-box;
  padding: 60px 0;
  position: relative;
  img.prev {
    position: absolute;
    top: 30%;
    left: 5%;
    width: 50px;
    height: auto;
    cursor: pointer;
  }
  img.next {
    position: absolute;
    top: 30%;
    right: 5%;
    width: 50px;
    height: auto;
    cursor: pointer;
  }
  .container {
    width: 1140px;
    margin: 0 auto;
    height: auto;
    overflow: hidden;
    .list {
      width: 9000px;
      &.mobile {
        display: none;
      }
    }
    .item {
      width: 253px;
      float: left;
      height: auto;
      border: 1px solid #cccccc;
      border-radius: 4px;
      background: #fff;
      margin-right: 40px;
      cursor: pointer;
      .nav {
        width: 100px;
        height: 5px;
        margin-top: 10px;
        .nav_item {
          height: 5px;
          width: 32%;
          float: left;
          position: relative;
          &::after,
          &::before {
            position: absolute;
            content: "";
            width: 0;
            height: 0;
            z-index: 2;
          }
          &:nth-of-type(1) {
            background: #54565a;
            &::after {
              right: 0;
              top: 0;
              border-left: 5px solid transparent;
              border-bottom: 5px solid #fff;
            }
          }
          &:nth-of-type(2) {
            background: #e04307;
            width: 34%;
            &::before {
              left: 0;
              top: 0;
              border-right: 5px solid transparent;
              border-top: 5px solid #fff;
            }
            &::after {
              right: 0;
              top: 0;
              border-left: 5px solid transparent;
              border-bottom: 5px solid #fff;
            }
          }
          &:nth-of-type(3) {
            background: #fd8204;
            &::before {
              left: 0;
              top: 0;
              border-right: 5px solid transparent;
              border-top: 5px solid #fff;
            }
          }
        }
      }
      .item_product_img {
        width: auto;
        height: 180px;
        margin: 15px auto;
        display: block;
        transition: all 0.35s;
        &:hover {
          transform: scale(1.1);
        }
      }
      .item_product_title {
        width: 100%;
        box-sizing: border-box;
        padding: 0 15px;
        font-size: 0.24rem;
        font-weight: bold;
        height: 0.48rem;
      }
      .item_product_desc {
        width: 100%;
        box-sizing: border-box;
        padding: 0 15px;
        color: #666;
        margin-top: 15px;
        font-size: 14px;
        height: 0.5rem;
        line-height: 1.4;
      }
      .item_product_cate {
        width: 100%;
        box-sizing: border-box;
        padding: 0 15px;
        margin-top: 5px;
        font-size: 12px;
        display: none;
        a {
          color: #f4c55c;
          transition: all 0.35s;
          font-size: 12px;
          text-decoration: none;
          cursor: pointer;
          &:hover {
            color: #fd8204;
          }
        }
      }
      .btn_more {
        width: 40px;
        height: 40px;
        float: right;
        position: relative;
        border-top: 1px solid #cccccc;
        border-left: 1px solid #cccccc;
        cursor: pointer;
        margin-top: 5px;
        img {
          cursor: pointer;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          height: 20px;
          width: auto;
        }
      }
    }
  }
  .btn_know_more {
    font-size: 16px;
    border: 2px solid #fd8204;
    border-radius: 25px;
    width: 130px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    font-weight: bold;
    transition: all 0.35s;
    margin: 45px auto 0;
    cursor: pointer;
    a {
      color: #fd8204;
      text-decoration: none;
      &:hover {
        background: #fd8204;
        color: #fff;
      }
    }
  }
  .mobile_switch {
    display: none;
  }
}
@media screen and (max-width: 750px) {
  #index_product {
    img.prev {
      &.web {
        display: none;
      }
    }
    img.next {
      &.web {
        display: none;
      }
    }
    .container {
      width: 100%;
      .list {
        width: 100%;
        display: none;
        &.mobile {
          display: block;
          overflow: hidden;
          box-sizing: border-box;
          padding: 0 30px;
        }
      }
      .item {
        display: block;
        float: left;
        box-sizing: border-box;
        margin-bottom: 20px;
        overflow: hidden;
        transition: all 0.35s;
        width: 50%;
        margin-right: 0;
        position: relative;
        height: 245px;
        .item_product_img {
          width: auto;
          height: 150px;
        }
        &.on {
          display: block;
        }
        .nav {
          .nav_item {
            height: 3px;
          }
        }
        .item_product_title {
          font-size: 0.7rem;
          line-height: 1.5;
          padding-right: 30px;
        }
        .item_product_desc {
          display: none;
        }
        .btn_more {
          position: absolute;
          width: 28px;
          height: 28px;
          bottom: 0;
          right: 0;
          img {
            height: 15px;
          }
        }
      }
    }
    .btn_know_more {
      margin-top: 2rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/Index/IndexProduct.vue